/* global wpApiSettings */
import { createAsyncThunk } from "@reduxjs/toolkit";
import { wpBase } from "../api/base";
import axios from "axios";

// CHECK IF FAVORITED
const checkIfFavorited = createAsyncThunk(
  "favorite/checkIfFavorited",
  async ({ author, userId }, { rejectWithValue }) => {
    try {
      const response = await wpBase.post(
        `/wp-json/fz-favorites/v1/check-favorite/`,
        {
          author: author,
          userId: userId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-WP-Nonce": wpApiSettings.nonce,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching data:", error);
      return rejectWithValue(error.message);
    }
  }
);

// REMOVE FAVORITES
const removeFavorite = createAsyncThunk(
  "favorite/removeFavorite",
  async ({ author, userId }, { rejectWithValue }) => {
    try {
      const response = await axios.delete(
        `/wp-json/fz-favorites/v2/comments/remove`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-WP-Nonce": wpApiSettings.nonce,
          },
          data: {
            author: author,
            user_id: userId,
          },
        }
      );

      return {
        author,
        status: response.data.status,
        deleted_rows: response.data.deleted_rows,
      };
    } catch (error) {
      console.error("Error removing favorite:", error);
      return rejectWithValue(error.message);
    }
  }
);

// GET ALL FAVORITES
const getAllFavorites = createAsyncThunk(
  "favorite/getAllFavorites",
  async ({ userId }, { rejectWithValue }) => {
    try {
      const response = await wpBase.get(
        `/wp-json/fz-favorites/v1/user-favorites/${userId}`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-WP-Nonce": wpApiSettings.nonce,
          },
        }
      );

      if (response.status === 200) {
        return response.data;
      } else {
        return rejectWithValue(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("Error getting all favorites:", error);
      return rejectWithValue(error.message);
    }
  }
);

// GET ALL FAVORITES WITH THEIR DATA
const getAllFavoritesData = createAsyncThunk(
  "favorite/getAllFavoritesData",
  async (cars, { rejectWithValue }) => {
    const promises = cars.map(async (car) => {
      let apiUrl;
      if (car.comment_content === "car" || car.comment_content === "motorcycle" || car.comment_content === "heavy-equipment" || car.comment_content === "rv") {
        apiUrl = `https://mc-api.marketcheck.com/v2/listing/${car.comment_content}/${car.comment_author}?api_key=${process.env.REACT_APP_MC_API_KEY}`;
      } else if(car.comment_content === "housing-for-sale" || car.comment_content === "housing-long-term" || car.comment_content === "housing-short-term") {
        apiUrl = `${wpApiSettings.root}fz-housing-favorite-details-api/v1/data?houseId=${car.comment_author}`;
      } else {
        apiUrl = `https://finditzstg.wpengine.com/wp-json/wp/v2/hp_listing/${car.comment_author}`;
      }

      try {
        const response = await axios.get(apiUrl);
        if(car.comment_content === "housing-for-sale" || car.comment_content === "housing-long-term" || car.comment_content === "housing-short-term") {
          return {
            ...response.data.data[0],
            comment_date: car.comment_date,
            type: car.comment_content,
          };
        } else {
          return {
            ...response.data,
            comment_date: car.comment_date,
            type: car.comment_content,
          };
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        return null; 
      }
    });

    try {
      const results = await Promise.all(promises);
      const filteredResults = results.filter((data) => data !== null);

      // Sort by comment_date
      filteredResults.sort(
        (a, b) => new Date(b.comment_date) - new Date(a.comment_date)
      );

      return filteredResults; // Return the sorted and filtered results
    } catch (error) {
      console.error("Error processing data:", error);
      return rejectWithValue("Failed to fetch car data");
    }
  }
);

export {
  checkIfFavorited,
  removeFavorite,
  getAllFavorites,
  getAllFavoritesData,
};
